import { gql } from '@apollo/client';

export const DELETE_PROGRAMME_REPORTER = gql`
  mutation DeleteProgrammeReporter($id: ID!) {
    programmeReporter: deleteProgrammeReporter(id: $id) {
      id
    }
  }
`;
